/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacLibra = [
  [
    "path",
    { d: "M3 16h6.857c.162-.012.19-.323.038-.38a6 6 0 1 1 4.212 0c-.153.057-.125.368.038.38H21" }
  ],
  ["path", { d: "M3 20h18" }]
];

export { ZodiacLibra as default };
//# sourceMappingURL=zodiac-libra.js.map
